'use client';

import { c as _c } from "react/compiler-runtime";
import { captureException } from '@sentry/nextjs';
import { useEffect, useState } from 'react';
import { useSearchHistoryStore } from '@/app/_components/SearchBar/_store/searchHistoryStore';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { postWelloTrack } from '@/utils/analytics/welloTrack';
import { useRollingStep } from './useRollingStep';
import { useTrendKeywords } from './useTrendKeywords';
export const useTrendKeyword = () => {
  const $ = _c(16);
  const [isOpen, setIsOpen] = useState(false);
  const {
    keywords,
    isPending
  } = useTrendKeywords();
  const step = useRollingStep(keywords.length, isOpen);
  const {
    push
  } = useCustomRouter();
  const addSearchHistory = useSearchHistoryStore(_temp);
  let t0;
  let t1;
  if ($[0] !== isOpen) {
    t0 = () => {
      if (!isOpen) {
        return;
      }
      const handleScroll = () => setIsOpen(false);
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [isOpen];
    $[0] = isOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== addSearchHistory || $[4] !== keywords || $[5] !== push) {
    t2 = keyword => {
      setIsOpen(false);
      addSearchHistory(keyword);
      const ranking = keywords.find(item => item.keyword === keyword)?.ranking;
      const clickParams = {
        btn_name: "\uC6F0\uB85C \uD0A4\uC6CC\uB4DC",
        content_name: keyword,
        ranking
      };
      trackGtmEvent(GTM_EVENT_TYPE.CLICK_BTN, clickParams);
      postWelloTrack({
        eventName: "clickWelloKeyword",
        dictionary: {
          url: `${window.location.pathname}${window.location.search}`,
          keyword,
          ranking
        }
      }).catch(captureException);
      push(ROUTES.SEARCH.withSearchParams({
        searchParams: {
          q: keyword
        }
      }));
    };
    $[3] = addSearchHistory;
    $[4] = keywords;
    $[5] = push;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const search = t2;
  const t3 = keywords[step % keywords.length];
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(_temp2);
    t5 = () => setIsOpen(false);
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isOpen || $[10] !== isPending || $[11] !== keywords || $[12] !== search || $[13] !== step || $[14] !== t3) {
    t6 = {
      keywords,
      step,
      isOpen,
      isPending,
      currentKeyword: t3,
      search,
      toggle: t4,
      close: t5
    };
    $[9] = isOpen;
    $[10] = isPending;
    $[11] = keywords;
    $[12] = search;
    $[13] = step;
    $[14] = t3;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(state) {
  return state.add;
}
function _temp2(previousIsOpen) {
  return !previousIsOpen;
}